import { isLessThanOne } from "../utils/helpers";

const normalizeBarValue = (value) => value ?? 0;
const normalizeBarDisplayValue = (value) => (isLessThanOne(value) ? "<1" : value ?? 0);

const formatDashboardData = (dashboardData) => {
    const charts = dashboardData?.result?.charts;
    if (!Array.isArray(charts)) return [];

    const idMap = {
        0: "claimsByAge",
        1: "genderDistribution",
        2: "claimsByTenure",
        3: "Claimsbydiagnosis",
        4: "Averageclaimdurationindays",
        5: "Reasonforclosure",
        6: "ltdSsOffsets",
        7: "claimsByWCOffset",
    };

    return charts.map((chart) => {
        const {
            id,
            title,
            description,
            accessibilityText,
            variant,
            indexBy,
            axisLabelOrientation,
            chartValueOrientation,
            chartValueType,
            layout,
            data,
            totalClaims,
        } = chart;


        const chartId = idMap[id] || String(id);
        const normalizedVariant = variant?.toLowerCase();

        const base = {
            id: chartId,
            title,
            description,
            accessibilityText,
            variant: normalizedVariant,
            indexBy,
            axisLabelOrientation,
            chartValueOrientation,
            chartValueType,
            layout,
            clientClaimCount: totalClaims,
        };
        // Check if data contains error messages
        if (data && data.message) {
            return {
                ...base,
                error: true,
                errorMessage:  data.message,
                data: [],
            };
        }

        if (normalizedVariant === "donut") {
            const dataArray = Array.isArray(data) ? data : [];

            if (data && data.message) {
                return {
                    ...base,
                    data: dataArray,
                };
            }

            const transformed = dataArray.map(group =>
                group.values.map(v => ({
                    gender: v.label,
                    value: v.value ?? 0
                }))
            );
            return { ...base, data: transformed };
        }

        const formattedData =
            data?.map((item) => ({
                [indexBy]: item.label || item.group || item[indexBy],
                Org: normalizeBarValue(item.selectedOrganizations),
                OrgDisplay: normalizeBarDisplayValue(item.selectedOrganizations),
                Industrypeers: normalizeBarValue(item.industryPeers),
                IndustrypeersDisplay: normalizeBarDisplayValue(item.industryPeers),
                unumclient: normalizeBarValue(item.unumBlock),
                unumclientDisplay: normalizeBarDisplayValue(item.unumBlock),
            })) || [];
        return {
            ...base,
            data: formattedData,
        };
    });
};

export default formatDashboardData;
